import {TAB_WIDTH, PartialComponentExport} from '../constants'
import type {WmlFile} from '@wix/document-services-types'

export const generateJsonFile = (componentExport: PartialComponentExport['other']): WmlFile<'json'> => ({
    type: 'json',
    content: JSON.stringify(componentExport, undefined, TAB_WIDTH)
})
